module.exports = __webpack_public_path__ + "static/105256777_662804704577837_5482796550852787685_o_optimized-9d267bea7f0dda6b6f3d553a53a6df63.jpg";